// account
export const LOGIN = 'login';
export const SIGNUP = 'signup';
export const LOGOUT = 'logout';
export const SIGN_OUT = 'signOut';
export const UPDATE_ACCOUNT = 'updateAccount';
export const FORGOT_PASSWORD = 'forgotPassword';
export const RESET_PASSWORD = 'resetPassword';
export const RESET_PASSWORD_AUTHED = 'resetPasswordAuthed';
export const GET_AUTH_ACCOUNT = 'getAuthAccount';
export const SYNC_ACCOUNT_ORGANIZATION = 'syncAccountOrganization';
export const CLEAR_ACCOUNT_ISLOADING = 'clearAccountIsLoading';

// fayda
export const CREATE_FAYDA_AUTH_URL = 'createFaydaAuthUrl';
export const FAYDA_EXCHANGE_CODE = 'faydaExchangeCode';
export const CLEAR_FAYDA_ISLOADING = 'clearFaydaIsLoading';

// organization
export const REGISTER_ORGANIZATION = 'registerOrganization';
export const SIGNUP_ORGANIZATION = 'signupOrganization';
export const GET_ORGANIZATIONS = 'getOrganizations';
export const GET_ORGANIZATION = 'getOrganization';
export const EDIT_ORGANIZATION = 'editOrganization';
export const DELETE_ORGANIZATION = 'deleteOrganization';
export const CLEAR_ORGANIZATION_ISLOADING = 'clearOrganizationIsLoading';

// employee
export const GET_EMPLOYEES = 'getEmployees';
export const GET_EMPLOYEE = 'getEmployee';
export const GET_EMPLOYEE_STATS = 'getEmployeeStats';
export const GET_EMPLOYEE_DIRECTORY = 'getEmployeeDirectory';
export const GET_EMPLOYEE_ACTIVITY = 'getEmployeeActivity';
export const REGISTER_EMPLOYEE = 'registerEmployee';
export const EDIT_EMPLOYEE = 'editEmployee';
export const INVITE_EMPLOYEE = 'inviteEmployee';
export const TOGGLE_EMPLOYEE_IS_ACTIVE = 'toggleEmployeeIsActive';
export const DELETE_EMPLOYEE = 'deleteEmployee';
export const UPLOAD_EMPLOYEE_PROFILE_PHOTO = 'uploadEmployeeProfilePhoto';
export const CLEAR_EMPLOYEES_ISLOADING = 'clearEmployeesIsLoading';

// employee_address
export const REGISTER_EMPLOYEE_ADDRESS = 'registerEmployeeAddress';
export const GET_EMPLOYEE_ADDRESSES = 'getEmployeeAddresses';
export const GET_EMPLOYEE_ADDRESS = 'getEmployeeAddress';
export const EDIT_EMPLOYEE_ADDRESS = 'editEmployeeAddress';
export const DELETE_EMPLOYEE_ADDRESS = 'deleteEmployeeAddress';
export const CLEAR_EMPLOYEE_ADDRESS_ISLOADING = 'clearEmployeeAddressIsLoading';

// employee_position
export const REGISTER_EMPLOYEE_POSITION = 'registerEmployeePosition';
export const GET_EMPLOYEE_POSITIONS = 'getEmployeePositions';
export const GET_EMPLOYEE_POSITION = 'getEmployeePosition';
export const EDIT_EMPLOYEE_POSITION = 'editEmployeePosition';
export const DELETE_EMPLOYEE_POSITION = 'deleteEmployeePosition';
export const GET_UNASSIGNED_EMPLOYEES = 'getUnassignedEmployees';
export const CLEAR_EMPLOYEE_POSITION_ISLOADING = 'clearEmployeePositionIsLoading';

// employee_salary
export const REGISTER_EMPLOYEE_SALARY = 'registerEmployeeSalary';
export const GET_EMPLOYEE_SALARIES = 'getEmployeeSalaries';
export const GET_EMPLOYEE_SALARY = 'getEmployeeSalary';
export const EDIT_EMPLOYEE_SALARY = 'editEmployeeSalary';
export const DELETE_EMPLOYEE_SALARY = 'deleteEmployeeSalary';
export const CLEAR_EMPLOYEE_SALARY_ISLOADING = 'clearEmployeeSalaryIsLoading';

// employee_salary_promotion
export const REGISTER_EMPLOYEE_SALARY_PROMOTION = 'registerEmployeeSalaryPromotion';
export const GET_EMPLOYEE_SALARY_PROMOTIONS = 'getEmployeeSalaries';
export const GET_EMPLOYEE_SALARY_PROMOTION = 'getEmployeeSalaryPromotion';
export const EDIT_EMPLOYEE_SALARY_PROMOTION = 'editEmployeeSalaryPromotion';
export const DELETE_EMPLOYEE_SALARY_PROMOTION = 'deleteEmployeeSalaryPromotion';
export const CLEAR_EMPLOYEE_SALARY_PROMOTION_ISLOADING = 'clearEmployeeSalaryPromotionIsLoading';

// employee_bank
export const REGISTER_EMPLOYEE_BANK = 'registerEmployeeBank';
export const GET_EMPLOYEE_BANKS = 'getEmployeeBanks';
export const GET_EMPLOYEE_BANK = 'getEmployeeBank';
export const EDIT_EMPLOYEE_BANK = 'editEmployeeBank';
export const DELETE_EMPLOYEE_BANK = 'deleteEmployeeBank';
export const CLEAR_EMPLOYEE_BANK_ISLOADING = 'clearEmployeeBankIsLoading';

// employee_education
export const REGISTER_EMPLOYEE_EDUCATION = 'registerEmployeeEducation';
export const GET_EMPLOYEE_EDUCATIONS = 'getEmployeeEducations';
export const GET_EMPLOYEE_EDUCATION = 'getEmployeeEducation';
export const EDIT_EMPLOYEE_EDUCATION = 'editEmployeeEducation';
export const DELETE_EMPLOYEE_EDUCATION = 'deleteEmployeeEducation';
export const CLEAR_EMPLOYEE_EDUCATION_ISLOADING = 'clearEmployeeEducationIsLoading';

// employee_leave
export const REGISTER_EMPLOYEE_LEAVE = 'registerEmployeeLeave';
export const GET_EMPLOYEE_LEAVES = 'getEmployeeLeaves';
export const GET_EMPLOYEE_LEAVE = 'getEmployeeLeave';
export const EDIT_EMPLOYEE_LEAVE = 'editEmployeeLeave';
export const APPROVE_EMPLOYEE_LEAVE = 'editEmployeeApprove';
export const REJECT_EMPLOYEE_LEAVE = 'editEmployeeReject';
export const CANCEL_EMPLOYEE_LEAVE = 'editEmployeeCancel';
export const DELETE_EMPLOYEE_LEAVE = 'deleteEmployeeLeave';
export const CLEAR_EMPLOYEE_LEAVE_ISLOADING = 'clearEmployeeLeaveIsLoading';

// employee_payroll
export const REGISTER_EMPLOYEE_PAYROLL = 'registerEmployeePayroll';
export const GET_EMPLOYEE_PAYROLLS = 'getEmployeePayrolls';
export const GET_EMPLOYEE_PAYROLL_STATS = 'getEmployeePayrollStats';
export const GET_EMPLOYEE_PAYROLL = 'getEmployeePayroll';
export const EDIT_EMPLOYEE_PAYROLL = 'editEmployeePayroll';
export const DELETE_EMPLOYEE_PAYROLL = 'deleteEmployeePayroll';
export const CLEAR_EMPLOYEE_PAYROLL_ISLOADING = 'clearEmployeePayrollIsLoading';

// employee_overtime
export const REGISTER_EMPLOYEE_OVERTIME = 'registerEmployeeOvertime';
export const GET_EMPLOYEE_OVERTIMES = 'getEmployeeOvertimes';
export const GET_EMPLOYEE_OVERTIMES_BY_EMPLOYEE = 'getEmployeeOvertimesByEmployee';
export const GET_EMPLOYEE_OVERTIME = 'getEmployeeOvertime';
export const EDIT_EMPLOYEE_OVERTIME = 'editEmployeeOvertime';
export const DELETE_EMPLOYEE_OVERTIME = 'deleteEmployeeOvertime';
export const UPDATE_OVERTIME_STATUS = 'updateOvertimeStatus';
export const GET_OVERTIME_ANALYTICS = 'getOvertimeAnalytics';
export const EXPORT_OVERTIME = 'exportOvertime';
export const CLEAR_EMPLOYEE_OVERTIME_ISLOADING = 'clearEmployeeOvertimeIsLoading';

// employee_contract
export const REGISTER_EMPLOYEE_CONTRACT = 'registerEmployeeContract';
export const GET_EMPLOYEE_CONTRACTS = 'getEmployeeContracts';
export const GET_EMPLOYEE_CONTRACT = 'getEmployeeContract';
export const EDIT_EMPLOYEE_CONTRACT = 'editEmployeeContract';
export const DELETE_EMPLOYEE_CONTRACT = 'deleteEmployeeContract';
export const CLEAR_EMPLOYEE_CONTRACT_ISLOADING = 'clearEmployeeContractIsLoading';

// employee_allowance
export const REGISTER_EMPLOYEE_ALLOWANCE = 'registerEmployeeAllowance';
export const GET_EMPLOYEE_ALLOWANCES = 'getEmployeeAllowances';
export const GET_EMPLOYEE_ALLOWANCE = 'getEmployeeAllowance';
export const EDIT_EMPLOYEE_ALLOWANCE = 'editEmployeeAllowance';
export const DELETE_EMPLOYEE_ALLOWANCE = 'deleteEmployeeAllowance';
export const CLEAR_EMPLOYEE_ALLOWANCE_ISLOADING = 'clearEmployeeAllowanceIsLoading';

// department
export const REGISTER_DEPARTMENT = 'registerDepartment';
export const GET_DEPARTMENTS = 'getDepartments';
export const GET_ORGANIZATIONAL_DEPARTMENTS = 'getOrganizationalDepartments';
export const GET_DEPARTMENT = 'getDepartment';
export const EDIT_DEPARTMENT = 'editDepartment';
export const DELETE_DEPARTMENT = 'deleteDepartment';
export const TOGGLE_DEPARTMENT_IS_ACTIVE = 'toggleDepartmentIsActive';
export const GET_DEPARTMENT_IMPACT = 'getDepartmentImpact';
export const CLEAR_DEPARTMENT_ISLOADING = 'clearDepartmentIsLoading';

// position
export const REGISTER_POSITION = 'registerPosition';
export const GET_POSITIONS = 'getPositions';
export const GET_POSITION = 'getPosition';
export const EDIT_POSITION = 'editPosition';
export const DELETE_POSITION = 'deletePosition';
export const TOGGLE_POSITION_IS_ACTIVE = 'togglePositionIsActive';
export const GET_POSITION_IMPACT = 'getPositionImpact';
export const CLEAR_POSITION_ISLOADING = 'clearPositionIsLoading';

// bank
export const REGISTER_BANK = 'registerBank';
export const GET_BANKS = 'getBanks';
export const GET_BANK = 'getBank';
export const EDIT_BANK = 'editBank';
export const DELETE_BANK = 'deleteBank';
export const CLEAR_BANK_ISLOADING = 'clearBankIsLoading';

// payroll_period
export const REGISTER_PAYROLL_PERIOD = 'registerPayrollPeriod';
export const GET_PAYROLL_PERIODS = 'getPayrollPeriods';
export const GET_PAYROLL_PERIOD = 'getPayrollPeriod';
export const EDIT_PAYROLL_PERIOD = 'editPayrollPeriod';
export const DELETE_PAYROLL_PERIOD = 'deletePayrollPeriod';
export const CLEAR_PAYROLL_PERIOD_ISLOADING = 'clearPayrollPeriodIsLoading';

// payroll
export const REGISTER_PAYROLL = 'registerPayroll';
export const GENERATE_PAYROLL = 'generatePayroll';
export const GET_PAYROLL_DETAILS = 'getPayrollDetails';
export const GET_PAYROLL_STATS_CHART = 'getPayrollStatsChart';
export const GET_EMPLOYEES_WITHOUT_SALARY = 'getEmployeesWithoutSalary';
export const GET_EMPLOYEES_WITH_SALARY = 'getEmployeesWithSalary';
export const GET_PAYROLL_COMPENSATION = 'getPayrollCompensation';
export const GET_PAYROLL_ANALYTICS = 'getPayrollAnalytics';
export const GET_PAYROLL_EMPLOYEE_ANALYTICS = 'getPayrollEmployeeAnalytics';
export const EXPORT_PAYROLL_REPORT = 'exportPayrollReport';
export const EXPORT_PAYROLL_CSV = 'exportPayrollCSV';
export const EXPORT_PAYROLL_BANK_REPORT_PDF = 'exportPayrollBankReportPDF';
export const EXPORT_EMPLOYEE_PAYROLL_SLIP_PDF = 'exportEmployeePayrollSlipPDF';
export const EXPORT_PAYROLL_ETAX = 'exportEmployeePayrollETax';
export const APPROVE_PAYROLL = 'approvePayroll';
export const EDIT_PAYROLL = 'editPayroll';
export const DELETE_PAYROLL = 'deletePayroll';
export const CLEAR_PAYROLL_ISLOADING = 'clearPayrollIsLoading';

// leave_type
export const REGISTER_LEAVE_TYPE = 'registerLeaveType';
export const GET_LEAVE_TYPES = 'getLeaveTypes';
export const GET_LEAVE_TYPE = 'getLeaveType';
export const EDIT_LEAVE_TYPE = 'editLeaveType';
export const DELETE_LEAVE_TYPE = 'deleteLeaveType';
export const CLEAR_LEAVE_TYPE_ISLOADING = 'clearLeaveTypeIsLoading';

// leave_request
export const REGISTER_LEAVE_REQUEST = 'registerLeaveRequest';
export const GET_LEAVE_REQUESTS = 'getLeaveRequests';
export const GET_LEAVE_REQUEST = 'getLeaveRequest';
export const GET_LEAVE_STATS = 'getLeaveStats';
export const APPROVE_LEAVE_REQUEST = 'approveLeaveRequest';
export const REJECT_LEAVE_REQUEST = 'rejectLeaveRequest';
export const CANCEL_LEAVE_REQUEST = 'cancelLeaveRequest';
export const EDIT_LEAVE_REQUEST = 'editLeaveRequest';
export const DELETE_LEAVE_REQUEST = 'deleteLeaveRequest';
export const CLEAR_LEAVE_REQUEST_ISLOADING = 'clearLeaveRequestIsLoading';

// leave_balance
export const REGISTER_LEAVE_BALANCE = 'registerLeaveBalance';
export const GET_LEAVE_BALANCES = 'getLeaveBalances';
export const GET_LEAVE_BALANCE = 'getLeaveBalance';
export const EDIT_LEAVE_BALANCE = 'editLeaveBalance';
export const DELETE_LEAVE_BALANCE = 'deleteLeaveBalance';
export const CLEAR_LEAVE_BALANCE_ISLOADING = 'clearLeaveBalanceIsLoading';

// leave_ledger
export const REGISTER_LEAVE_LEDGER = 'registerLeaveLedger';
export const GET_LEAVE_LEDGERS = 'getLeaveLedgers';
export const GET_LEAVE_LEDGER = 'getLeaveLedger';
export const EDIT_LEAVE_LEDGER = 'editLeaveLedger';
export const DELETE_LEAVE_LEDGER = 'deleteLeaveLedger';
export const CLEAR_LEAVE_LEDGER_ISLOADING = 'clearLeaveLedgerIsLoading';

// holiday
export const GET_CALENDAR_HOLIDAYS = 'getCalendarHolidays';
export const GET_HOLIDAYS = 'getHolidays';
export const CHECK_HOLIDAY = 'checkHoliday';
export const REGISTER_CALENDAR_HOLIDAY = 'registerCalendarHoliday';
export const REMOVE_HOLIDAY = 'removeHoliday';
export const CLEAR_HOLIDAYS_ISLOADING = 'clearLeaveTypeIsLoading';

// overtime_setting
export const REGISTER_OVERTIME_SETTING = 'registerOvertimeSetting';
export const GET_OVERTIME_SETTINGS = 'getOvertimeSettings';
export const CHECK_OVERTIME_SETTING_IS_USED = 'checkOvertimeSettingIsUsed';
export const GET_OVERTIME_SETTING = 'getOvertimeSetting';
export const EDIT_OVERTIME_SETTING = 'editOvertimeSetting';
export const DELETE_OVERTIME_SETTING = 'deleteOvertimeSetting';
export const CLEAR_OVERTIME_SETTING_ISLOADING = 'clearOvertimeSettingIsLoading';

// allowance_type
export const REGISTER_ALLOWANCE_TYPE = 'registerAllowanceType';
export const GET_ALLOWANCE_TYPES = 'getAllowanceTypes';
export const GET_ALLOWANCE_TYPE = 'getAllowanceType';
export const EDIT_ALLOWANCE_TYPE = 'editAllowanceType';
export const DELETE_ALLOWANCE_TYPE = 'deleteAllowanceType';
export const CLEAR_ALLOWANCE_TYPE_ISLOADING = 'clearAllowanceTypeIsLoading';

// attendance_logs
export const REGISTER_ATTENDANCE_LOG = 'registerAttendanceLog';
export const GET_ATTENDANCE_LOGS = 'getAttendanceLogs';
export const GET_ATTENDANCE_REPORT = 'getAttendanceReport';
export const GET_EMPLOYEES_ATTENDANCE_LOGS = 'getEmployeeAttendanceLogs';
export const GET_EMPLOYEES_ATTENDANCE_DAYS = 'getEmployeeAttendanceDays';
export const GET_CALENDAR_ATTENDANCE_LOGS = 'getCalendarAttendanceLogs';
export const GET_ATTENDANCE_ANALYTICS = 'getAttendanceAnalytics';
export const GET_ATTENDANCE_DAY_RECORDS = 'getAttendanceDayRecords';
export const EXPORT_ATTENDANCE = 'exportAttendance';
export const CLEAR_ATTENDANCE_LOG_ISLOADING = 'clearAttendanceLog IsLoading';

// drive (the Files module)
export const GET_DRIVE_TREE = 'getDriveTree';
export const BROWSE_DRIVE = 'browseDrive';
export const GET_DRIVE_USAGE = 'getDriveUsage';
export const CREATE_DRIVE_FOLDER = 'createDriveFolder';
export const UPDATE_DRIVE_FOLDER = 'updateDriveFolder';
export const DELETE_DRIVE_FOLDER = 'deleteDriveFolder';
export const INIT_DRIVE_UPLOAD = 'initDriveUpload';
export const COMPLETE_DRIVE_UPLOAD = 'completeDriveUpload';
export const CANCEL_DRIVE_UPLOAD = 'cancelDriveUpload';
export const UPDATE_DRIVE_FILE = 'updateDriveFile';
export const DELETE_DRIVE_FILE = 'deleteDriveFile';
export const GET_DRIVE_DOWNLOAD_LINK = 'getDriveDownloadLink';
export const CLEAR_DRIVE_ISLOADING = 'clearDriveIsLoading';

// attendance_schedule
export const REGISTER_ATTENDANCE_SCHEDULE = 'registerAttendanceSchedule';
export const GET_ATTENDANCE_SCHEDULES = 'getAttendanceSchedules';
export const GET_ATTENDANCE_SCHEDULE = 'getAttendanceSchedule';
export const EDIT_ATTENDANCE_SCHEDULE = 'editAttendanceSchedule';
export const DELETE_ATTENDANCE_SCHEDULE = 'deleteAttendanceSchedule';
export const CLEAR_ATTENDANCE_SCHEDULE_ISLOADING = 'clearAttendanceScheduleIsLoading';

// attendance_shift
export const REGISTER_ATTENDANCE_SHIFT = 'registerAttendanceShift';
export const GET_ATTENDANCE_SHIFTS = 'getAttendanceShifts';
export const GET_ATTENDANCE_SHIFT = 'getAttendanceShift';
export const EDIT_ATTENDANCE_SHIFT = 'editAttendanceShift';
export const DELETE_ATTENDANCE_SHIFT = 'deleteAttendanceShift';
export const CLEAR_ATTENDANCE_SHIFT_ISLOADING = 'clearAttendanceShiftIsLoading';

// employee_attendance_shift
export const REGISTER_EMPLOYEE_ATTENDANCE_SHIFT = 'registerEmployeeAttendanceShift';
export const GET_EMPLOYEE_ATTENDANCE_SHIFTS = 'getEmployeeAttendanceShifts';
export const GET_EMPLOYEE_ATTENDANCE_SHIFT = 'getEmployeeAttendanceShift';
export const EDIT_EMPLOYEE_ATTENDANCE_SHIFT = 'editEmployeeAttendanceShift';
export const DELETE_EMPLOYEE_ATTENDANCE_SHIFT = 'deleteEmployeeAttendanceShift';
export const CLEAR_EMPLOYEE_ATTENDANCE_SHIFT_ISLOADING = 'clearEmployeeAttendanceShiftIsLoading';

// file
export const REGISTER_FILE = 'registerFile';
export const GET_FILES = 'getFiles';
export const GET_FILE = 'getFile';
export const EDIT_FILE = 'editFile';
export const DELETE_FILE = 'deleteFile';
export const CLEAR_FILE_ISLOADING = 'clearFileIsLoading';

// payroll_component
export const REGISTER_PAYROLL_COMPONENT = 'registerPayrollComponent';
export const GET_PAYROLL_COMPONENTS = 'getPayrollComponents';
export const GET_PAYROLL_COMPONENT = 'getPayrollComponent';
export const EDIT_PAYROLL_COMPONENT = 'editPayrollComponent';
export const DELETE_PAYROLL_COMPONENT = 'deletePayrollComponent';
export const CLEAR_PAYROLL_COMPONENT_ISLOADING = 'clearPayrollComponentIsLoading';

// employee_payroll_component
export const REGISTER_EMPLOYEE_PAYROLL_COMPONENT = 'registerEmployeePayrollComponent';
export const GET_EMPLOYEE_PAYROLL_COMPONENTS = 'getEmployeePayrollComponents';
export const GET_EMPLOYEE_PAYROLL_COMPONENT = 'getEmployeePayrollComponent';
export const EDIT_EMPLOYEE_PAYROLL_COMPONENT = 'editEmployeePayrollComponent';
export const TOGGLE_EMPLOYEE_PAYROLL_COMPONENT_IS_ACTIVE = 'toggleEmployeePayrollComponentIsActive';
export const DELETE_EMPLOYEE_PAYROLL_COMPONENT = 'deleteEmployeePayrollComponent';
export const CLEAR_EMPLOYEE_PAYROLL_COMPONENT_ISLOADING = 'clearEmployeePayrollComponentIsLoading';

// guideline
export const REGISTER_GUIDELINE = 'registerGuideline';
export const GET_GUIDELINES = 'getGuidelines';
export const GET_GUIDELINE = 'getGuideline';
export const EDIT_GUIDELINE = 'editGuideline';
export const DELETE_GUIDELINE = 'deleteGuideline';
export const CLEAR_GUIDELINE_ISLOADING = 'clearGuidelineIsLoading';

// job_application
export const REGISTER_JOB_APPLICATION = 'registerJobApplication';
export const GET_JOB_APPLICATIONS = 'getJobApplications';
export const GET_JOB_APPLICATION = 'getJobApplication';
export const EDIT_JOB_APPLICATION = 'editJobApplication';
export const UPDATE_JOB_APPLICATION_STATUS = 'updateJobApplicationStatus';
export const GET_JOB_APPLICATION_STATS = 'getJobApplicationStats';
export const DELETE_JOB_APPLICATION = 'deleteJobApplication';
export const CLEAR_JOB_APPLICATION_ISLOADING = 'clearJobApplicationIsLoading';

// job_post
export const REGISTER_JOB_POST = 'registerJobPost';
export const GET_JOB_POSTS = 'getJobPosts';
export const GET_JOB_POST = 'getJobPost';
export const EDIT_JOB_POST = 'editJobPost';
export const TOGGLE_JOB_POST_IS_ACTIVE = 'toggleJobPostIsActive';
export const DELETE_JOB_POST = 'deleteJobPost';
export const CLEAR_JOB_POST_ISLOADING = 'clearJobPostIsLoading';

// stats
export const GET_DASHBOARD_STATS = 'getDashboardStats';
export const GET_EMPLOYEE_DASHBOARD_STATS = 'getEmployeeDashboardStats';
export const GET_ADMIN_DASHBOARD_STATS = 'getAdminDashboardStats';
export const CLEAR_STATS_ISLOADING = 'clearStatsIsLoading';

// reports
export const GET_EMPLOYEE_REPORTS = 'getEmployeeReports';
export const GET_PAYROLL_REPORTS = 'getPayrollReports';
export const GET_PROJECT_REPORTS = 'getProjectReports';
export const GET_REPORT_FACETS = 'getReportFacets';
export const GENERATE_REPORT = 'generateReport';
export const EXPORT_REPORT = 'exportReport';
export const CLEAR_REPORT_RESULT = 'clearReportResult';

// project
export const REGISTER_PROJECT = 'registerProject';
export const GET_PROJECTS = 'getProjects';
export const GET_PROJECT = 'getProject';
export const EDIT_PROJECT = 'editProject';
export const TOGGLE_PROJECT_IS_ACTIVE = 'toggleProjectIsActive';
export const DELETE_PROJECT = 'deleteProject';
export const CLEAR_PROJECT_ISLOADING = 'clearProjectIsLoading';

// client
export const REGISTER_CLIENT = 'registerClient';
export const GET_CLIENTS = 'getClients';
export const GET_CLIENT = 'getClient';
export const EDIT_CLIENT = 'editClient';
export const DELETE_CLIENT = 'deleteClient';
export const CLEAR_CLIENT_ISLOADING = 'clearClientIsLoading';

// billing_invoicing
export const REGISTER_BILLING_AND_INVOICING = 'registerBillingInvoicing';
export const GET_BILLING_AND_INVOICINGS = 'getBillingInvoicings';
export const GET_BILLING_AND_INVOICING = 'getBillingInvoicing';
export const EDIT_BILLING_AND_INVOICING = 'editBillingInvoicing';
export const GET_BILLING_AND_INVOICING_STATS = 'getBillingInvoicingStats';
export const DELETE_BILLING_AND_INVOICING = 'deleteBillingInvoicing';
export const CLEAR_BILLING_AND_INVOICING_ISLOADING = 'clearBillingInvoicingIsLoading';
export const DOWNLOAD_INVOICE_PDF = 'downloadInvoicePDF';

// invoice_item
export const REGISTER_INVOICE_ITEM = 'registerInvoiceItem';
export const GET_INVOICE_ITEMS = 'getInvoiceItems';
export const GET_INVOICE_ITEM = 'getInvoiceItem';
export const EDIT_INVOICE_ITEM = 'editInvoiceItem';
export const DELETE_INVOICE_ITEM = 'deleteInvoiceItem';
export const CLEAR_INVOICE_ITEM_ISLOADING = 'clearInvoiceItemIsLoading';

// milestone
export const REGISTER_MILESTONE = 'registerMilestone';
export const GET_MILESTONES = 'getMilestones';
export const GET_MILESTONE = 'getMilestone';
export const EDIT_MILESTONE = 'editMilestone';
export const DELETE_MILESTONE = 'deleteMilestone';
export const CLEAR_MILESTONE_ISLOADING = 'clearMilestoneIsLoading';

// project_employee
export const REGISTER_PROJECT_EMPLOYEE = 'registerProjectEmployee';
export const GET_PROJECT_EMPLOYEES = 'getProjectEmployees';
export const GET_PROJECT_EMPLOYEE = 'getProjectEmployee';
export const EDIT_PROJECT_EMPLOYEE = 'editProjectEmployee';
export const DELETE_PROJECT_EMPLOYEE = 'deleteProjectEmployee';
export const CLEAR_PROJECT_EMPLOYEE_ISLOADING = 'clearProjectEmployeeIsLoading';

// project_transaction
export const REGISTER_PROJECT_TRANSACTION = 'registerProjectTransaction';
export const GET_PROJECT_TRANSACTIONS = 'getProjectTransactions';
export const GET_PROJECT_TRANSACTION = 'getProjectTransaction';
export const GET_PROJECT_TRANSACTION_STATS = 'getProjectTransactionStats';
export const EDIT_PROJECT_TRANSACTION = 'editProjectTransaction';
export const DELETE_PROJECT_TRANSACTION = 'deleteProjectTransaction';
export const CLEAR_PROJECT_TRANSACTION_ISLOADING = 'clearProjectTransactionIsLoading';

// project_file
export const REGISTER_PROJECT_FILE = 'registerProjectFile';
export const GET_PROJECT_FILES = 'getProjectFiles';
export const GET_PROJECT_FILE = 'getProjectFile';
export const EDIT_PROJECT_FILE = 'editProjectFile';
export const DELETE_PROJECT_FILE = 'deleteProjectFile';
export const CLEAR_PROJECT_FILE_ISLOADING = 'clearProjectFileIsLoading';

// project_employee_role
export const REGISTER_PROJECT_EMPLOYEE_ROLE = 'registerProjectEmployeeRole';
export const GET_PROJECT_EMPLOYEE_ROLES = 'getProjectEmployeeRoles';
export const GET_PROJECT_EMPLOYEE_ROLE = 'getProjectEmployeeRole';
export const EDIT_PROJECT_EMPLOYEE_ROLE = 'editProjectEmployeeRole';
export const DELETE_PROJECT_EMPLOYEE_ROLE = 'deleteProjectEmployeeRole';
export const CLEAR_PROJECT_EMPLOYEE_ROLE_ISLOADING = 'clearProjectEmployeeRoleIsLoading';

// export_template
export const REGISTER_EXPORT_TEMPLATE = 'registerExportTemplate';
export const GET_EXPORT_TEMPLATES = 'getExportTemplates';
export const GET_EXPORT_TEMPLATE = 'getExportTemplate';
export const EDIT_EXPORT_TEMPLATE = 'editExportTemplate';
export const DELETE_EXPORT_TEMPLATE = 'deleteExportTemplate';
export const GENERATE_EXPORT_TEMPLATE = 'generateExportTemplate';
export const CLEAR_EXPORT_TEMPLATE_ISLOADING = 'clearExportTemplateIsLoading';
export const DUPLICATE_EXPORT_TEMPLATE = 'duplicateExportTemplate';
export const GET_EXPORT_DATASETS = 'getExportDatasets';
export const GET_EXPORT_DATASET_FIELDS = 'getExportDatasetFields';
export const RUN_EXPORT_TEMPLATE = 'runExportTemplate';

// employee_offboarding
export const REGISTER_EMPLOYEE_OFFBOARDING = 'registerEmployeeOffboarding';
export const GET_EMPLOYEE_OFFBOARDINGS = 'getEmployeeOffboardings';
export const GET_EMPLOYEE_OFFBOARDING = 'getEmployeeOffboarding';
export const EDIT_EMPLOYEE_OFFBOARDING = 'editEmployeeOffboarding';
export const DELETE_EMPLOYEE_OFFBOARDING = 'deleteEmployeeOffboarding';
export const CLEAR_EMPLOYEE_OFFBOARDING_ISLOADING = 'clearEmployeeOffboardingIsLoading';

// employee_offboarding_checklist
export const TOGGLE_EMPLOYEE_OFFBOARDING_CHECKLIST_STATUS = 'toggleEmployeeOffboardingChecklistStatus';

// employee_offboarding_template
export const REGISTER_EMPLOYEE_OFFBOARDING_TEMPLATE = 'registerEmployeeOffboardingTemplate';
export const GET_EMPLOYEE_OFFBOARDING_TEMPLATES = 'getEmployeeOffboardingTemplates';
export const GET_EMPLOYEE_OFFBOARDING_TEMPLATE = 'getEmployeeOffboardingTemplate';
export const EDIT_EMPLOYEE_OFFBOARDING_TEMPLATE = 'editEmployeeOffboardingTemplate';
export const DELETE_EMPLOYEE_OFFBOARDING_TEMPLATE = 'deleteEmployeeOffboardingTemplate';
export const CLEAR_EMPLOYEE_OFFBOARDING_TEMPLATE_ISLOADING = 'clearEmployeeOffboardingTemplateIsLoading';

// knowledge_base_category
export const REGISTER_KNOWLEDGE_BASE_CATEGORY = 'registerKnowledgeBaseCategory';
export const GET_KNOWLEDGE_BASE_CATEGORIES = 'getKnowledgeBaseCategories';
export const GET_KNOWLEDGE_BASE_CATEGORY = 'getKnowledgeBaseCategory';
export const EDIT_KNOWLEDGE_BASE_CATEGORY = 'editKnowledgeBaseCategory';
export const DELETE_KNOWLEDGE_BASE_CATEGORY = 'deleteKnowledgeBaseCategory';
export const CLEAR_KNOWLEDGE_BASE_CATEGORY_ISLOADING = 'clearKnowledgeBaseCategoryIsLoading';

// knowledge_base_article
export const REGISTER_KNOWLEDGE_BASE_ARTICLE = 'registerKnowledgeBaseArticle';
export const GET_KNOWLEDGE_BASE_ARTICLES = 'getKnowledgeBaseArticles';
export const GET_KNOWLEDGE_BASE_ARTICLE = 'getKnowledgeBaseArticle';
export const EDIT_KNOWLEDGE_BASE_ARTICLE = 'editKnowledgeBaseArticle';
export const DELETE_KNOWLEDGE_BASE_ARTICLE = 'deleteKnowledgeBaseArticle';
export const CLEAR_KNOWLEDGE_BASE_ARTICLE_ISLOADING = 'clearKnowledgeBaseArticleIsLoading';

// router_loader
export const UPDATE_ROUTER_LOADER = 'updateRouterLoader';

// error
export const CLEAR_ERRORMSG = 'clearErrorMessage';
export const UPDATE_ERRORMSG = 'updateErrorMessage';

// chat
export const GET_CHAT_CONVERSATIONS = 'getChatConversations';
export const GET_CHAT_CONVERSATION = 'getChatConversation';
export const OPEN_CHAT_DIRECT = 'openChatDirect';
export const CREATE_CHAT_GROUP = 'createChatGroup';
export const UPDATE_CHAT_CONVERSATION = 'updateChatConversation';
export const ADD_CHAT_MEMBERS = 'addChatMembers';
export const REMOVE_CHAT_MEMBER = 'removeChatMember';
export const LEAVE_CHAT_CONVERSATION = 'leaveChatConversation';
export const MUTE_CHAT_CONVERSATION = 'muteChatConversation';
export const MARK_CHAT_READ = 'markChatRead';
export const GET_CHAT_MESSAGES = 'getChatMessages';
export const SEND_CHAT_MESSAGE = 'sendChatMessage';
export const RETRY_CHAT_MESSAGE = 'retryChatMessage';
export const DISCARD_CHAT_MESSAGE = 'discardChatMessage';
export const DELETE_CHAT_MESSAGE = 'deleteChatMessage';
export const GET_CHAT_DIRECTORY = 'getChatDirectory';
export const GET_CHAT_NOTIFICATIONS = 'getChatNotifications';
export const MARK_CHAT_NOTIFICATIONS_SEEN = 'markChatNotificationsSeen';
export const MARK_CHAT_NOTIFICATIONS_READ = 'markChatNotificationsRead';
export const GET_CHAT_UNREAD = 'getChatUnread';
export const SET_ACTIVE_CHAT_CONVERSATION = 'setActiveChatConversation';
export const CHAT_SOCKET_EVENT = 'chatSocketEvent';
export const CLEAR_CHAT = 'clearChat';
